export enum ToastType {
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
}
